module.exports = __webpack_public_path__ + "img/slssr-currency-guide-1.abdb66ff.png";